import styled from 'styled-components'

export const MenuListContainer = styled.div`
  flex: 1;
  padding: 15px 30px;
`

export const CategorySection = styled.div`
  padding: 25px 0;
`

export const MenuCards = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`
